// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"5329f3b2","256":"0f700d89","287":"1ac54a5a","481":"53045a5f","782":"69cd0d27"}[chunkId] + ".chunk.js";
};